import { LayoutHOC } from "base/ui/layout/layout";
import { createMachineBreakdownTime } from "./machineBreakdownTime";



export const createMachineBreakdownTimePage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createMachineBreakdownTime());
};